import list from './list'
import edit from './edit'
import create from './create'
import icon from '@material-ui/icons/Person'

const broadcasters = { list, edit, create, icon, options: { label: 'Broadcasters' } }

export default broadcasters
